import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { APP_URL_CHAT, CHAT_TYPE, STORAGE_KEY_SELF_CREATED_CHAT } from '../../../const';
import storageService from '../../../service/StorageService';
import { getUser, toggleAuthModal } from '../../../store/slices/authSlice';
import {
    setMultyChatInvationModalVisibility,
    startChatWithAdvisor,
    startChatWithAdvisorByActivities
} from '../../../store/slices/chatsSlice';
import styles from './styles.module.scss';

const MarketPlaceActionButton = ({
    isToCatalog = false,
    text,
    advisorId = '',
    advisorAlias = '',
    classes = [],
    chatType = CHAT_TYPE.SINGLE,
    isTransparent = false,
    isActivities = false
}) => {
    const user = useSelector(getUser);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [openChatLoading, setOpenChatLoading] = useState(false);
    const { t } = useTranslation();

    const openChat = useCallback(async () => {
        if (openChatLoading) {
            return;
        }
        if (chatType === CHAT_TYPE.MULTIPLY && !user?.id) {
            dispatch(toggleAuthModal({ trigger: true, step: 1 }));
            return;
        }
        setOpenChatLoading(true);
        const routStringPath = advisorId ? advisorId : `alias/${advisorAlias}`;

        const result = isActivities
            ? await dispatch(startChatWithAdvisorByActivities(advisorId))
            : await dispatch(startChatWithAdvisor(routStringPath));

        if (result?.meta?.requestStatus === 'fulfilled') {
            const responseAlias = result?.payload?.advisor?.alias;
            const advisor = responseAlias ? responseAlias : advisorAlias;
            setOpenChatLoading(false);
            storageService.add(STORAGE_KEY_SELF_CREATED_CHAT, result?.payload?.id);
            navigate(`/${APP_URL_CHAT}/${advisor}/${result?.payload?.id}`);
            if (chatType === CHAT_TYPE.MULTIPLY) {
                dispatch(setMultyChatInvationModalVisibility(true));
            }
        } else {
            setOpenChatLoading(false);
        }
    }, [advisorAlias, advisorId, dispatch, navigate, openChatLoading, user?.id]);
    useEffect(() => {
        setOpenChatLoading(false);
    }, []);

    return isToCatalog ? (
        <Link to={'/catalog'} className={classNames(styles.btn, ...classes)}>
            {text || t('buttons.chatNow')}
        </Link>
    ) : (
        <button
            className={classNames(styles.btn, { [styles.transparent]: isTransparent }, ...classes, {
                [styles.noEvents]: openChatLoading
            })}
            onClick={openChat}
        >
            {openChatLoading ? (
                <span className={styles.loading}>Loading</span>
            ) : chatType === CHAT_TYPE.SINGLE ? (
                text || t('buttons.chatNow')
            ) : (
                text || t('buttons.multiChat')
            )}
        </button>
    );
};

export default MarketPlaceActionButton;
